import React from 'react';
import CasinoPlayersOnlineContent from './CasinoPlayersOnlineContent';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';

export default function CasinoPlayersOnline() {
  return (
    <CasinoContainer title={'Number of players online for'}>
      <CasinoPlayersOnlineContent />
    </CasinoContainer>
  );
}
